module.exports = __webpack_public_path__ + "img/green.31bab905.png";